var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCakephp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 50 50",
    style: {
      enableBackground: "new 0 0 50 50"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#C82334;}\r\n\t.st1{fill:#B8271A;}\r\n\t.st2{fill:#CCB463;}\r\n\t.st3{fill:#DFD26F;}\r\n\t.st4{fill:#E6D273;}\r\n\t.st5{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.6,4.3l3.6-2.5L33,5.7l3.9-1.5l0.9,4.1L42.1,8l-0.3,4.3l4.1,0.6l-1.4,4l3.8,2l-2.5,3.2l3.3,3l-3.3,2.7 l2.4,3.6l-3.8,2l1.6,4.2l-4.6,0.3l1.1,4.4l-4.8-0.2L37,46.1l-3.9-1.5l-2,3.8L27.7,46l-2.8,3.2L22.1,46l-3.4,2.4l-2-3.8l-3.9,1.5 l-0.4-4.3l-4.7,0.5l0.3-4.6l-4.4,0l1.8-4.3l-3.8-2l2.2-3.5l-3.1-2.7l3.1-2.8L1.5,19l3.8-2.1l-1.4-3.7L8,12.2L7.7,8l4.3,0.3l0.9-4.2 l3.9,1.6l1.9-3.9l3.4,2.4L24.9,1L27.6,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M41,31.7c0,3.8-7,6.9-15.7,6.9S9.5,35.5,9.5,31.7c0-3.8,7-6.9,15.7-6.9S41,27.9,41,31.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M24.5,12.7l5.1,9L29.3,29l7.8,3.3l2.6-15.4L24.5,12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M39.7,16.9l0.7-2.1c0,0-1.4,9.2-1.6,10.4c-0.2,1.2-1.5,6.9-1.5,6.9l-0.2,0.1l0.7-4.5l-9.5-3.3l0.4-1.1l9.3,3 l0.6-3.3l-11.8-3.8l0-1.3l12,3.7L39.7,16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M9.4,15.9l1.8,13.3c0,0,0,3.8,5,6.4C21.2,38.1,29,37,29,37l0.6-15.3c-1.5,0.2-3.1,0.3-4.8,0.3 C17,22,10.5,19.3,9.4,15.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.1,32.2c-7.3,0.6-13.6-0.7-18.3-5.7l0.2,1.8c3.8,4.3,10.2,5.6,18,5.3L29.1,32.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M29.4,27c-7.3,0.6-14.5,0-19.1-5l0.2,1.6c3.8,4.3,11.1,5.1,18.8,4.8L29.4,27"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M40.4,14.7c0,0.8-0.3,1.5-0.7,2.2l-15.3-4.2l5.1,9c-1.5,0.2-3.1,0.3-4.8,0.3c-8.6,0-15.6-3.3-15.6-7.3 c0-4,7-7.3,15.6-7.3S40.4,10.6,40.4,14.7"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17.000000, 180.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-7.3-142.2c-0.5-0.3-1-0.4-1.6-0.4c-1.4,0-2.2,1-2.2,2.8c0,1.9,0.8,2.9,2.3,2.9c0.6,0,1.1-0.2,1.6-0.5 l0.1,1.6c-0.6,0.2-1.3,0.4-2,0.4c-2.4,0-4-1.7-4-4.3c0-2.7,1.6-4.3,3.9-4.3c0.7,0,1.3,0.1,2,0.4L-7.3-142.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M-1.4-136.9c0,0.4,0,0.8,0.1,1.3H-3l-0.1-0.8c-0.5,0.6-1.1,0.9-1.9,0.9c-1.1,0-1.8-0.8-1.8-1.9 c0-1.4,1-2.2,3-2.2h0.6v-0.2c0-0.7-0.4-1-1.2-1c-0.6,0-1.1,0.2-1.6,0.6l-0.1-1.4c0.8-0.3,1.5-0.4,2.2-0.4c2.1,0,2.6,0.8,2.6,2.8 V-136.9L-1.4-136.9z M-3.7-138.6c-0.9,0-1.3,0.3-1.3,1c0,0.5,0.3,0.8,0.8,0.8c0.7,0,1.1-0.5,1.1-1.5v-0.4 C-3.4-138.6-3.6-138.6-3.7-138.6L-3.7-138.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M1.7-144.7v5.3l1.6-2.5h1.9l-1.9,2.9l2.1,3.4h-2l-1.6-3v3h-1.8v-9.1H1.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M8.7-136.8c0.6,0,1.1-0.2,1.6-0.5l0.1,1.3c-0.7,0.3-1.3,0.4-2,0.4c-2,0-3.1-1.2-3.1-3.2c0-2,1.1-3.3,2.7-3.3 c1.7,0,2.7,1.2,2.7,3.4c0,0.1,0,0.3,0,0.4H7.2C7.3-137.3,7.8-136.8,8.7-136.8L8.7-136.8z M9-139.6c0-0.8-0.3-1.2-0.9-1.2 c-0.6,0-0.9,0.5-1,1.5H9C9-139.5,9-139.6,9-139.6L9-139.6z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-117.7-146.4c1,0,1.8,0.1,2.3,0.4c0.8,0.5,1.3,1.3,1.3,2.5c0,1.9-1.1,2.8-3.3,2.8h-0.5v3.3h-2.1v-9H-117.7L-117.7-146.4z  M-117.9-142.2h0.5c0.9,0,1.3-0.4,1.3-1.4c0-1-0.4-1.3-1.3-1.3h-0.4V-142.2L-117.9-142.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-111.7-146.4v3.5h2.2v-3.5h2.1v9h-2.1v-3.8h-2.2v3.8h-2.1v-9H-111.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-104.2-146.4c1,0,1.8,0.1,2.3,0.4c0.8,0.5,1.3,1.3,1.3,2.5c0,1.9-1.1,2.8-3.3,2.8h-0.5v3.3h-2.1v-9H-104.2L-104.2-146.4z  M-104.4-142.2h0.5c0.9,0,1.3-0.4,1.3-1.4c0-1-0.4-1.3-1.3-1.3h-0.4V-142.2L-104.4-142.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakephp);
export default __webpack_public_path__ + "static/media/cakephp.a45f3988a9b56b30bc0229dd1740e9c7.svg";
export { ForwardRef as ReactComponent };